<div class="latch-expansion-panel-header" (click)="expanded = !expanded">
  <ng-content select="latch-expansion-panel-header"></ng-content>
  <div class="latch-expansion-panel-header-spacer"></div>
  <span [class]="expanded ? 'latch-icon-arrow-up' : 'latch-icon-arrow-down'"></span>
</div>
<div class="latch-expansion-panel-content" *ngIf="expanded">
  <ng-content></ng-content>
</div>
